import styled from 'styled-components';

export const ExtraData = styled.td`
  padding: 0px;
`;

export const ExtraContent = styled.div`
  display: flex;
`;

export const BlankWidthBlock = styled.div`
  width: 5px;
  min-width: 5px;
  max-width: 5px;
`;

export const BlankHeightBlock = styled.div`
  height: 5px;
  min-height: 5px;
  max-height: 5px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: #fcfcfc;
  border-radius: 5px;
  padding: 5px;
`;